// TelcoTrack — unique č.p. / address-point assignment (RÚIAN → BUDOVA).
// Spatial snap must not copy a house number onto a parcel-only pin.

/** Max distance (m, S-JTSK) for assigning an `address_point` to a BUDOVA. */
export const ADDRESS_ASSIGNMENT_MAX_DISTANCE_M = 30;
